import { accessToken } from "./sessionKey";
//@ts-ignore
import { AxiosInstance, API_ROOT } from "@careinfo/axios-service";

let instance: any;

// Initialize the instance before making any API calls
const initInstance = async () => {
  if (!instance) {
    instance = await AxiosInstance();
  }
};

// Get data from API
export const getApiData = async (url, param = null) => {
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    return e.response;
  }
  return response;
};
export const downloadApiDataGET = async (data: any) => {
  const { url, fileName, formData } = data;
  let response: any;
  try {
    response = await instance({
      method: "POST",
      url: url,
      data: formData,
      responseType: "blob",
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    return error.response;
  }
  return response;
};

// Post data to API
export const postApiData = async (data) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

export const postApiChunkFormData = async (data: any) => {
  const { url, formData, setProgress, chunkIndex, totalChunks } = data;
  let response;
  await initInstance();
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          ((chunkIndex + 1) / totalChunks) * 100
        );
        setProgress(percentCompleted);
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    return e.response;
  }
  return response;
};

// Update data
export const patchApiData = async (data) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

export const deleteApiData = async ({
  url,
  setError,
}: {
  url: string;
  setError?: any;
}) => {
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "DELETE",
      url: `${url}`,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // If response is empty (like 204 No Content), just return null
          if (!responseData) return null;
          try {
            return JSON.parse(responseData);
          } catch {
            return responseData;
          }
        },
      ],
      validateStatus: (status) => {
        return (status >= 200 && status < 300) || status === 204;
      },
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError?.(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }

  if (response?.status === 204) {
    return { status: 204, data: null, message: "Deleted successfully" };
  }

  return response;
};

export { API_ROOT };
